app.controller('certifiedValuesController', async function ($rootScope, $filter, $scope, safeApply, appealsService, systemService) {

  $scope.currentCounty = null
  $scope.tableLoading  = true
  $scope.appliedFilter = { filter: {}, description: '', filter_id: 0, filter_index: 0, filter_active: false }
  $scope.currentFilter = { filter: {}, filter_active: false }

  let table

  let countyList                      = await systemService.functionCall({ type: "countyList", active_only: false })
      $scope.countyList               = countyList.data.data
  let taxYearResults                  = await systemService.functionCall({ type: "getCurrentTaxYear" })
      $scope.tax_year                 = taxYearResults.data.data
  let getCertifiedValueSourcesResults = await systemService.functionCall({ type: "getAppData", item: "certified_value_sources" })
      $scope.CertifiedValueSources    = getCertifiedValueSourcesResults.data.data[0].data_json
  let getCustomTableFiltersResults    = await systemService.functionCall({ type: "getCustomTableFilters", table_name: "certified_values" })
  $scope.CustomTableFilters           = getCustomTableFiltersResults.data.data
  safeApply($scope)
  
  // console.log('$rootScope.user_info :>> ', $rootScope.user_info);
console.log('$scope.CustomTableFilters :>> ', $scope.CustomTableFilters);

  $scope.setCounty = async (county) => {
    $scope.tableLoading       = true
    $scope.currentCounty      = county
    let appealsServiceResults = await appealsService.getAppealsByCounty({ cad_code: $scope.currentCounty.cad_code, tax_year: $scope.tax_year })    
    $scope.appeals            = appealsServiceResults.data.data
    // console.log('$scope.appeals :>> ', $scope.appeals);
    if ($.fn.dataTable.isDataTable('#certifiedValuesTable')) {
      $('#certifiedValuesTable').DataTable().destroy()
      $('#certifiedValuesTable').empty()
      table = null
    }
    loadDataTable($scope.appeals)
  }

  function loadDataTable(records) {    
    const columns = [
        { title: "ID",                          data: 'id',                      className: 'dt-body-center dt-head-center' },        
        { title: "User ID",                     data: 'user_id',                 className: 'dt-body-right dt-head-right' },
        { title: "Prop ID",                     data: 'prop_id',                 className: 'dt-body-right dt-head-right' },
        { title: "Appeal ID",                   data: 'appeal_id',               className: 'dt-body-right dt-head-right' },
        { title: "Type",                        data: 'type',                    className: 'dt-body-center dt-head-center' },
        { title: "Account #",                   data: 'cad_account',             className: 'dt-body-right dt-head-right' },
        { title: "Address",                     data: 'address',                 className: 'dt-body-left dt-head-left' },
        { title: "Owner Name",                  data: 'owner_name',              className: 'dt-body-left dt-head-left' },
        { title: "Notified Market",             data: 'notified_market',         className: 'dt-body-right dt-head-right' },
        { title: "Notified Appraised",          data: 'notified_appraised',      className: 'dt-body-right dt-head-right' },
        { title: "Certified Market",            data: 'certified_market',        className: 'dt-body-right dt-head-right' },
        { title: "Certified Appraised",         data: 'certified_appraised',     className: 'dt-body-right dt-head-right' },        
        { title: "Market Reduction",            data: 'market_reduction',        className: 'dt-body-right dt-head-right' },
        { title: "Appraised Reduction",         data: 'appraised_reduction',     className: 'dt-body-right dt-head-right' },        
        { title: "Tax Savings",                 data: 'tax_savings',             className: 'dt-body-right dt-head-right' },
        { title: "Resolved By",                 data: 'resolved_by',             className: 'dt-body-center dt-head-center' },
        { title: "EDIT",                        data: null,                      className: 'dt-body-center dt-head-center' }        
    ]
    let config = {
      data        : records,
      scrollY     : 'calc(100vh -  420px)',
      scrollX     : true,
      pagingType  : 'full_numbers',
      dom         : 'BQfrtip',
      fixedColumns: true,
      keys        : false,
      pageLength  : 25,
      deferRender : true,      
      lengthMenu  : [
        [10, 25, 50, 100, -1],
        ['10 rows', '25 rows', '50 rows', '100 rows', 'Show all']
      ],
      buttons: [
        'pageLength', 'spacer', 'csv', 'excel',        
        'spacer',
        { extend: 'searchPanes',
          config: {
            cascadePanes: true,
            viewTotal   : true }
        },
        'searchPanesClear', 'spacer',
        { extend: 'searchBuilder'}
      ],
      language: {
        searchBuilder: {
          button: 'Filter',
        }
      },
      columns: columns,
      columnDefs: [
        {
          searchPanes: {
            show: true
          },
          targets: findTargets(columns, ['type',])
        },
        {
          render: function (data, type, row) {
            return $filter('currency')(data, "$", 0)
          }, targets: findTargets(columns, ['notified_market', 'notified_appraised', 'certified_market', 'certified_appraised', 'market_reduction','appraised_reduction'])
        },
        {
          render: function (data, type, row) {
            return $filter('currency')(data, "$", 2)
          }, targets: findTargets(columns, ['tax_savings'])
        },
        {
          render: function (data, type, row) {
            return '<button class="btn btn-primary btn-sm edit-button" type="button">Edit</button>'
          }, targets: -1
        } 
      ],
      "fnDrawCallback": function (oSettings) {
        // console.log('DataTables has redrawn the table')        
      },
      "initComplete": function (settings, json) {
        $scope.tableLoading = false        
        // Event listener for Edit Button
        $('#certifiedValuesTable tbody').on('click', '.edit-button', function (e) {
          var data = table.row($(this).parents('tr')).data()
          editAppeal(data)
        })
        // activate tooltips for filter dropdown
        tippy(document.querySelectorAll('.tippy'))
      }
    }
    table = $('#certifiedValuesTable').DataTable(config)    
    table.draw()
    safeApply($scope)
    
    // Event listener to detect when the filter changes
    table.on('search.dt', function () {
      try {
        $scope.currentFilter = { filter: JSON.stringify(table.searchBuilder.getDetails()).toString(), filter_active: JSON.stringify(table.searchBuilder.getDetails()).toString().length > 2 }
        if ($scope.currentFilter.filter_active == false && $scope.appliedFilter.filter_active == true) {
          $scope.appliedFilter = { description: '', filter: {}, filter_id: 0, filter_index: 0, filter_active: false }
        }
        safeApply($scope)  
      } catch (error) {   }      
    })
  }
 
  // Filter dropdown functions --------------------------------------------------------------
  $scope.applyFilter = async (index) => { 
    const filter = $scope.CustomTableFilters[index].filter_criteria
    $scope.appliedFilter = {
      description  : $scope.CustomTableFilters[index].filter_description,
      filter       : JSON.stringify(filter),
      filter_active: true,
      filter_id    : $scope.CustomTableFilters[index].id,
      filter_index : index
    }
    $scope.currentFilter = {
      filter       : JSON.stringify(filter),
      filter_active: true
    }
    table.searchBuilder.rebuild(filter)
    safeApply($scope)
  }
  $scope.clearFilters = async () => { 
    table.searchBuilder.rebuild({})
    $scope.appliedFilter = { description: '', filter: {}, filter_id: 0, filter_index: 0, filter_active: false }
  }
  $scope.createNewFilter = () => {
    $scope.updateSaveFilterModalObj = {
      filter_name       : '',
      filter_description: '',
      action            : 'save'
    }
    var myModal = new bootstrap.Modal(document.getElementById('update-filter-modal'))
    myModal.show()
    safeApply($scope)    
  }
  $scope.saveNewFilter = async () => { 
    let obj = {
      table_name        : 'certified_values',
      filter_description: $scope.updateSaveFilterModalObj.filter_description,
      filter_name       : $scope.updateSaveFilterModalObj.filter_name,
      filter_criteria   : table.searchBuilder.getDetails(),
      author            : $rootScope.user_info.initials
    }
    let saveTableFilterResults = await systemService.functionCall({ type: "saveTableFilter", data: obj })
    console.log('saveTableFilterResults :>> ', saveTableFilterResults)    
    if (saveTableFilterResults.data.success) {      
      $scope.CustomTableFilters = saveTableFilterResults.data.data      
      const activeFilter = table.searchBuilder.getDetails()
      // Find the newly added filter and set item to it
      const newFilter      = $scope.CustomTableFilters.find(filter => filter.filter_name == $scope.updateSaveFilterModalObj.filter_name && filter.author == $rootScope.user_info.initials)
      const item           = $scope.CustomTableFilters[newFilter.index]
      $scope.appliedFilter = {
        description  : item.filter_description,
        filter       : JSON.stringify(activeFilter),
        filter_id    : item.id,
        filter_index : newFilter.index,
        filter_active: true,
      }      
      $scope.currentFilter = {
        filter       : $scope.appliedFilter.filter,
        filter_active: true
      }
      safeApply($scope)      
    } else {
    }
  }
  $scope.updateFilter = () => {
    let item                        = $scope.CustomTableFilters[$scope.appliedFilter.filter_index]
    $scope.updateSaveFilterModalObj = {
      filter_name       : item.filter_name,
      filter_description: item.filter_description,
      action            : 'update'
    }
    var myModal = new bootstrap.Modal(document.getElementById('update-filter-modal'))
    myModal.show()
    safeApply($scope)    
  }
  $scope.saveUpdatedFilter = async () => {  
    const activeFilter = table.searchBuilder.getDetails()
    let obj = {
      filter_name       : $scope.updateSaveFilterModalObj.filter_name,
      filter_description: $scope.updateSaveFilterModalObj.filter_description,
      filter_criteria   : activeFilter,
      id                : $scope.appliedFilter.filter_id
    }
    let updateTableFiltersResults           = await systemService.functionCall({ type: "updateTableFilters", data: obj })
    
    $scope.appliedFilter.filter             = JSON.stringify(activeFilter).toString(),
    $scope.appliedFilter.filter_active      = true,
    $scope.appliedFilter.filter_description = $scope.updateSaveFilterModalObj.filter_description,
    $scope.appliedFilter.filter_name        = $scope.updateSaveFilterModalObj.filter_name
    
    $scope.CustomTableFilters[$scope.appliedFilter.filter_index].filter_description = $scope.updateSaveFilterModalObj.filter_description
    $scope.CustomTableFilters[$scope.appliedFilter.filter_index].filter_name        = $scope.updateSaveFilterModalObj.filter_name
    $scope.CustomTableFilters[$scope.appliedFilter.filter_index].filter_criteria    = activeFilter
    safeApply($scope)
  }

  $scope.deleteFilter = async (index) => {
    console.log('$scope.CustomTableFilters[index] :>> ', $scope.CustomTableFilters[index].id);
    Swal.fire({
      title             : 'Are you sure?',
      text              : `You want to delete this filter?\n${$scope.CustomTableFilters[index].filter_description}`,
      icon              : 'warning',
      showCancelButton  : true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor : '#d33',
      confirmButtonText : 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let item = $scope.CustomTableFilters[index]
        let deleteTableFilterResults = await systemService.functionCall({ type: "deleteTableFilter", filter_id: item.id })
        if (deleteTableFilterResults.data.success) {
          if ($scope.appliedFilter.filter_index == index) { 
            $scope.clearFilters()
          }
          $scope.CustomTableFilters.splice(index, 1)
          toastr.success('Filter deleted successfully')
          safeApply($scope)
        }  
      }
    })    
  }

  $scope.getDetails = async () => { 
    let stored = table.searchBuilder.getDetails();
    console.log('stored :>> ', stored);
    console.log('JSON.stringify(stored, null, "\t") :>> ', JSON.stringify(stored, null));
    return stored
  }
  $scope.setDetails = async () => {    
    let d = { "criteria": [{ "condition": ">", "data": "Tax Savings", "origData": "tax_savings", "type": "num-fmt", "value": ["500"] }], "logic": "AND" }
    table.searchBuilder.rebuild(d);
  }
  // ---------------------------------------------------------------


  async function editAppeal(data) {
    $scope.appeal_modal_data = data
    var myModal              = new bootstrap.Modal(document.getElementById('certified-values-modal'))
    myModal.show()
    safeApply($scope)
    var myModalEl = document.getElementById('certified-values-modal')
    myModalEl.addEventListener('shown.bs.modal', function (event) {
      document.getElementById("certified-values-input").focus()
    })
  }
  $scope.updateValues = async () => { 
    let obj = {
      appeal_id       : $scope.appeal_modal_data.appeal_id,
      certified_market: $scope.appeal_modal_data.certified_market,
      resolved_by     : $scope.appeal_modal_data.resolved_by
    }
    let updateCertifiedValueResults = await appealsService.updateCertifiedValue(obj)
    let updatedCalculatedFields     = updateCertifiedValueResults.data.data[1][0]
    console.log('updateCertifiedValueResults :>> ', updateCertifiedValueResults);
    
    //Fields being updated from the DB, calculated fields are being updated for the frontend
    $scope.appeals[$scope.appeal_modal_data.index].certified_appraised = updatedCalculatedFields.certified_appraised
    


    $scope.appeals[$scope.appeal_modal_data.index].certified_market    = $scope.appeal_modal_data.certified_market
    $scope.appeals[$scope.appeal_modal_data.index].resolved_by         = $scope.appeal_modal_data.resolved_by
        
    table.rows().invalidate().draw()  // Forces table to redraw with new data
  }
 

  // Utility Functions ---------------------------------------------------------
  function findTargets(columns, targets) {
    let result = []
    for (let i = 0; i < columns.length; i++) {
      if (targets.includes(columns[i].data)) result.push(i)
    }
    return result
  }
  // END:  Utility Functions ---------------------------------------------------  

 })